import { VERSION_KEY_PATTERN } from './sessionProcessingContract'

export interface ProcessingVersion {
  major: number
  minor: number
}

export const PROCESSING_VERSION: Readonly<ProcessingVersion> = {
  major: 1,
  minor: 0,
}

export const PROCESSING_VERSION_KEY = `${PROCESSING_VERSION.major}.${PROCESSING_VERSION.minor}`

export function processingVersionOf(
  versionKey: string
): ProcessingVersion | null {
  if (!VERSION_KEY_PATTERN.test(versionKey)) return null
  const [major, minor] = versionKey.split('.').map(Number)
  return { major, minor }
}

export const isReadableProcessingVersion = (versionKey: string): boolean =>
  processingVersionOf(versionKey)?.major === PROCESSING_VERSION.major
